import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Csp5020Service } from '../../CSPService/CSP5020/csp5020.service';
import { Csp5020Class } from '../../CSPClass/CSP5020/csp5020-class';
@Component({
  selector: 'kt-csp5020-view',
  templateUrl: './csp5020-view.component.html',
  styleUrls: ['./csp5020-view.component.scss']
})
export class Csp5020ViewComponent implements OnInit {

  lblPageTitle: string = "";
  OneTimeFeeList: any[] = [];
  AnnualFeeList: any[] = [];
  SemesterFeeList: any[] = [];
  HostelFeeList: any[] = [];
  TransportFeeList: any[] = [];
  OtherFeeList: any[] = [];
  constructor(private router: Router,public dialogRef: MatDialogRef<Csp5020ViewComponent>, private objCsp5020Service:Csp5020Service,private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.onGetDatas();
  }
    onGetDatas() {
    if (localStorage.getItem('currentUser') != null) {
         var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
         var classobj = new Csp5020Class();
         classobj.UserNam= userLoginDetails.UserNam;
         this.objCsp5020Service.CourseFee(classobj).subscribe((data) => {
          //CourseFee Tabs Lists
          this.OneTimeFeeList = data.Item1 || [];
          this.AnnualFeeList= data.Item2 || [];
          this.SemesterFeeList=data.Item3 || [];
          this.HostelFeeList=data.Item4 || [];
          this.TransportFeeList=data.Item5 || [];
          this.OtherFeeList=data.Item6 || [];
         });
         this.changeDetectorRef.detectChanges();
    }
  }


indianFormatter = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

formatIN(value: number): string {
  const num = Number(value) || 0;
  return this.indianFormatter.format(num);
}

//Total Calculations for One Time Fee Tab    
OneTimeTotalAmountToPay(): number {
  return this.OneTimeFeeList.reduce((sum, item) => {
    const value = Number(String(item.amt_to_pay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OneTimeTotalAmountPaid(): number {
  return this.OneTimeFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_paid).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OneTimeTotalAmountDue(): number {
  return this.OneTimeFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_due).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
//End of Total Calculations for One Time Fee Tab


//Total Calculations for Annual Fee Tab

AnnualTotalAmountToPay(): number {
  return this.AnnualFeeList.reduce((sum, item) => {
    const value = Number(String(item.amt_to_pay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

AnnualTotalAmountPaid(): number {
  return this.AnnualFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_paid).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

AnnualTotalAmountDue(): number {
  return this.AnnualFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_due).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
//End of Total Calculations for Annual Fee Tab

//Total Calculations for Semester Fee Tab

SemesterTotalAmountToPay(): number {
  return this.SemesterFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_topay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

SemesterTotalAmountPaid(): number {
  return this.SemesterFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_paid).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

SemesterTotalAmountDue(): number {
  return this.SemesterFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_due).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
//End of Total Calculations for Semester Fee Tab

//Total Calculations for Hostel Fee Tab


HostelTotalAmountToPay(): number {
  return this.HostelFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_topay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

HostelTotalAmountPaid(): number {
  return this.HostelFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_paid ).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

HostelTotalAmountDue(): number {
  return this.HostelFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_due).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
//End of Total Calculations for Hostel Fee Tab

//Total Calculations for Transport Fee Tab


TransportTotalAmountToPay(): number {
  return this.TransportFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_topay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

TransportTotalAmountPaid(): number {
  return this.TransportFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_paid).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

TransportTotalAmountDue(): number {
  return this.TransportFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_due).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
//End of Total Calculations for Transport Fee Tab

//Total Calculations for Other Fee Tab

OtherFeeTotalAmountToPay(): number {
  return this.OtherFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_topay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OtherFeeTotalAmountPaid(): number {
  return this.OtherFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_paid).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OtherFeeTotalAmountDue(): number {
  return this.OtherFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_due).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
//End of Total Calculations for Other Fee Tab
  onClose() {
  if (this.dialogRef) {
    this.dialogRef.close();
  }
}


   getComponentTitle() {
    let result =  "CourseFee Details";
    return result;
   }
}
